import React, {Component} from "react"
import {Link} from 'react-router'
import {injectIntl} from 'react-intl'
import LogoImage from "../../../images/cogoland/Cogo_Logo.png"
import FooterPublic from "../../../components/FooterPublic"
import Spinner from "../../../components/Spinner"
import Alert from "../../../components/Alert"
import Form from "../../../components/form/Form"
import {Input} from 'formsy-react-components'
import {FormattedMessage} from "react-intl"
import {INPUT_STYLE_ELEMENT_ONLY} from "../../../constants"

class LoginView extends Component {

  constructor() {
    super()
    this.state = {
      loading: false,
      error: null,
      disabled: true
    }
  }

  componentWillMount() {
    this.setState({loading: false, error: null})
  }

  componentWillReceiveProps(nextProps) {
    this.setState({loading: nextProps.loading, error: nextProps.error})
  }


  login = (data) => {
    this.props.login(data)
  }

  enableSubmitButton = ()=> {
    this.setState({
      disabled: false
    });
  }

  disableSubmitButton = ()=> {
    this.setState({
      disabled: true
    });
  }

  render() {
    const inputStyle = INPUT_STYLE_ELEMENT_ONLY

    const formatMessage = this.props.intl.formatMessage

    return (
      <div style={{width: '100%', height: '100%'}} className="gray-bg">
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div>
            <div style={ {'marginTop': '50px', 'marginBottom': '50px'} }>
              <img src={LogoImage} alt="" className="full-width"/>
            </div>
            <h3>
              <FormattedMessage
                id="login.welcome"
                defaultMessage={`Welcome to Cogo`}
              />
            </h3>

            <Alert show={this.state.error} message={this.state.error ? this.state.error.message : ""}/>
            <Spinner show={this.state.loading}/>
            <div className="m-t">

              <Form
                onSubmit={this.login}
                onValid={this.enableSubmitButton}
                onInvalid={this.disableSubmitButton}
                validatePristine={false}
                ref="myform">
                <div className="form-group">
                  <Input
                    name="emailAddress"
                    value=""
                    label="Email Address"
                    type="text"
                    validations="isEmail"
                    validationErrors={{
                      isEmail: formatMessage({id:"input.error.email"})
                    }}
                    placeholder={formatMessage({id:'input.placeholder.email'})}
                    {...inputStyle}
                    required
                  />
                </div>
                <div className="form-group">
                  <Input
                    name="password"
                    value=""
                    type="password"
                    label="Password"
                    placeholder={formatMessage({id:'input.placeholder.password'})}
                    {...inputStyle}
                    required
                  />
                </div>
                <button className="btn btn-primary block full-width m-b"
                       formNoValidate={false} type="submit"
                       disabled={this.state.loading || this.state.disabled}
                       defaultValue="Register">
                  <FormattedMessage
                    id="button.login"
                    defaultMessage={`Login`}
                  />
                </button>
              </Form>


            </div>
            <FooterPublic/>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(LoginView)



// WEBPACK FOOTER //
// ./src/routes/Login/components/LoginView.js